var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"orders"},[_c('SidebarAccount'),_c('div',{staticClass:"allOrders"},[_c('h2',{staticClass:"allOrders__title"},[_vm._v("Meus Pedidos")]),_c('OrderHideShow')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }